import { exportAssetListByProductCategory } from '../../services/exportAssetListBTProductCategory'

const EXPORT_FUNCTION_MAP: Record<number, string> = {
  1:  'ExportMicroSCADAAssets',
  2:  'ExportIEDAssets',
  3:  'ExportRTUAssets',
  4:  'ExportWirelessAssets',
  6:  'ExportGPQSSAssets',
  13: 'ExportHVAssets',
  14: 'ExportHVAssets',
  15: 'ExportHVAssets',
  16: 'ExportHVAssets',
  17: 'ExportHVAssets',
  18: 'ExportHVAssets',
  19: 'ExportTransformersAssets',
  20: 'ExportTransformersAssets',
  21: 'ExportTransformersAssets',
  22: 'ExportTransformersAssets',
  23: 'ExportESSAssets',
  24: 'ExportTransformersAssets',
}

export async function triggerExport(categoryId: number, action: string): Promise<void> {
  const functionName = EXPORT_FUNCTION_MAP[categoryId]
  if (!functionName) return
  const exportType = action === 'pdf' ? 'PDF' : 'Excel'
  await exportAssetListByProductCategory({ functionName, categoryId, exportType })
}